import { fontSizes } from 'styles/constants/fonts';

export const serifFontFamily = 'Flame-Regular';
export const sansFontFamily = 'Flame-RegularSans';
export const boldFontFamily = 'Flame-Bold';
export const baseFontSize = 15;

// primitives go here (NOT design tokens or screen specific stuff)
export const _primitive = {
  fontFamily: { $headers: serifFontFamily, $body: sansFontFamily, $bold: boldFontFamily },
  fontSizes,
  $borderRadius: 10,

  // agnostic colors
  $black: '#000',
  $white: '#fff',
  $error: 'rgb(209,69,69)',
  $disabledText: 'rgba(0,0,0,0.55)',
  $disabledTextReversed: 'rgba(255,255,255,0.51)',
  $blackOpacity80: 'rgba(0,0,0,0.8)',
  $blackOpacity70: 'rgba(0,0,0,0.7)',
  $blackOpacity50: 'rgba(0,0,0,0.5)',
  $blackOpacity30: 'rgba(0,0,0,0.3)',
  $blackOpacity20: 'rgba(0,0,0,0.2)',
  $blackOpacity10: 'rgba(0,0,0,0.1)',
  $blackOpacity4: 'rgba(0,0,0,0.04)',
  $whiteOpacity30: 'rgba(255,255,255,0.3)',
  $whiteOpacity50: 'rgba(255,255,255,0.5)',
  $whiteOpacity10: 'rgba(255,255,255,0.1)',
  $whiteOpacity4: 'rgba(255,255,255,0.04)',

  // brand colors
  $bbqBrown: '#502314',
  $bbqBrownOpacity10: 'rgba(80, 35, 20, 0.10)',
  $bbqBrownOpacity15: 'rgba(80, 35, 20, 0.15)',
  $bbqBrownOpacity20: 'rgba(80, 35, 20, 0.2)',
  $mayoEggWhite: '#F8F1E7',
  $fieryRed: 'rgb(214,35,0)',
  $crunchyGreen: 'rgb(25,135,55)',
  $flamingOrange: 'rgb(255,135,50)',
  $meltyYellow: 'rgb(255,170,0)',
  $meltyYellowDark45: '#E59900',
  $meltyYellowDark40: '#CC8800',
  $meltyYellowOpacity10: 'rgba(255, 170, 0, 0.10)',
  $meltyYellowOpacity20: 'rgba(255, 170, 0, 0.20)',
  $lightMustard: '#FFC94F',
  $fieryRedOpacity10: 'rgba(214,35,0,0.1)',
  $fieryRedOpacity30: 'rgba(214, 35, 0, 0.3)',
  $fieryRedDarken10: 'rgb(163,27,0)',
  $fieryRedHover: 'rgba(167,27,0,1)',
  $fieryRedPressed: 'rgba(167,27,0,1)',
  $chkingOrange: '#D8601E',
  $blueWalmart: '#0053E2',
  $blueLight: '#F2F8FD',
  $errorLight: '#F7D5D4',
  $successLight: '#D5F7D4',
  $lightBrown: '#EEE8DE',
  $warningLight: '#FFCFAD',
  $disabledNoOpacity: '#E9E2D5',
  $crownColor: '#FFAA00',
  $alertRed: '#AF2420',
  $bbqRed: '#rgba(175, 36, 32, 1)',
  $surfacesWhite: '#999999',
  $shadowColor: 'rgba(73, 73, 73, 0.2)',

  // font weights
  $fontWeightNormal: 400,
  $fontWeightHeavy: 700,

  // legacy grey palette (BK brown-tinted neutrals)
  $greyOne: '#2b0200',
  $greyTwo: '#9f816f',
  $greyThree: '#693f34',
  $greyFour: '#bba391',
  $greyFive: '#d7c7b5',
  $greySix: '#845f50',
  $greySeven: '#340000',
  $greyEight: '#4e201d',
  // NOTE: legacy grey.nine = $blackOpacity4, grey.ten = $blackOpacity10 (deduped)
  $greyEleven: '#F5F5F5',

  $disabledTan: '#d4c7b7',
} as const;
